"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class QpErrorCode {
    static Required = 0;
    static NotParsable = 1;
    static DoesNotExist = 2;
    static AtLeastOneRequired = 3;
    static MultipleResults = 4;
    static NotSupported = 5;
    static Incompatible = 6;
    static Invalid = 7;
}
exports.default = QpErrorCode;
